import _ from 'lodash';
import moment from 'moment';

import env from '@/config/env';
import { isNilOrEmpty, parseCurrencyToNumber } from '@/utils/infrastructure';
import Comparison from './comparison';
import Date from './date';
import Logical from './logical';
import Math from './math';
import Numbers from './number';
import Regexp from './regularExpression';
import String from './string';
import Time from './time';

function isDateOnly(date) {
  return date.hour() === 0 && date.minute() === 0 && date.second() === 0;
}

function parseValue(value, input) {
  if (isNilOrEmpty(value)) return value;
  if (isNaN(value)) {
    const format = document.querySelector(`[name="${input}"]`)?.getAttribute('format');
    let date = moment(value, format || Date._TryGuessDateFormat(value), true);

    if (!date.isValid()) date = moment(value, true);
    if (!date.isValid()) date = moment(value, env.DATE_PARSE_FORMAT, true);
    if (!date.isValid()) date = moment(value, env.DATE_TIME_PARSE_FORMAT, true);
    if (date.isValid()) {
      return date.format(isDateOnly(date) ? env.DATE_PARSE_FORMAT : env.DATE_TIME_PARSE_FORMAT);
    }
  }

  return parseCurrencyToNumber(value);
}

/**
 * Global function to get the value of an input referenced in a formula
 * @param {String|HTMLElement} input
 * @param {Boolean} [usedInFormula]
 * @returns
 */
const getInputFormulaValue = (input, usedInFormula = false) => {
  if (_.isString(input)) {
    const el = document.querySelector(`#${input}`) ?? document.querySelector(`[name="${input}"]`);

    if (el?.classList.contains('ant-select')) {
      const selection = el.querySelector('.ant-select-selector .ant-select-selection-item');
      return usedInFormula
        ? parseValue(selection?.innerHTML, input) ?? ''
        : selection?.innerHTML ?? '';
    }

    return usedInFormula ? parseValue(el?.value, input) ?? '' : el?.value ?? '';
  }

  return usedInFormula ? parseValue(input?.value, input) ?? '' : input?.value ?? '';
};

export const replaceFieldValuesInFormula = (formula, options = { fields: [], form: null }) => {
  let updatedFormula = formula;

  options.fields.forEach((n) => {
    // selectors does not store values within the input
    const name = _.split(n, '.').pop();
    const item = options.form?.getFieldValue(name);
    const value = parseCurrencyToNumber(item?.value || item);

    const isValid = !moment.isMoment(value) && !isNilOrEmpty(value);
    let replacement = `getInputFormulaValue('${name}', true)`;

    if (isValid) {
      const num = _.replace(value, /,/g, '');
      replacement = isNaN(num) ? _.toString(`"${value}"`) : parseFloat(num);
    }

    updatedFormula = _.replace(formula, new RegExp(_.toString(`{{${n}}}`), 'g'), replacement);
  });

  return updatedFormula;
};

/** Namespace to serve all available formulae */
const CoreFormula = (() => {
  return {
    ...Comparison,
    ...Date,
    ...Logical,
    ...Math,
    ...Regexp,
    ...String,
    ...Time,
    ...Numbers,
    isDateOnly,
    getInputFormulaValue,
  };
})();

export default CoreFormula;
